import { trans } from "../../../utils/utilsTrans";

const ModalTutorial = ({ title, text, onNext, position, index, total, onValidate }) => {
  let containerClass = 'left-0'
  let triangleClass = 'left-24'
  if (position === 'center') {
    containerClass = 'left-[50%] -translate-x-1/2 '
    triangleClass = 'left-[50%] -translate-x-1/2'
  } else if (position === 'right') {
    containerClass = 'right-0'
    triangleClass = 'right-24'
  }
  return (
    <div
      className={
        'p-24 bg-primaryDark1 text-white absolute top-[100%] mt-24 rounded-8 w-[300px] shadow-lg z-20 animate-fromTop ' +
        containerClass
      }
    >
      <div
        className={
          'absolute -top-16 border border-x-[24px] border-b-[16px] border-transparent border-b-primaryDark1 ' +
          triangleClass
        }
      />
      {index && total ? (
        <span className='block mb-24 text-xs text-primaryLight2'>
          {index} sur {total}
        </span>
      ) : null}
      <span className='block mb-8 font-semibold'>{title}</span>
      <span className='text-[13px] mb-24 block'>{text}</span>
      <div className='flex items-center justify-between'>
        {!onValidate ? (
          <button className={'my-8 text-sm ' + (!onNext ? 'mx-auto' : '')}>
            Passer l‘intro
          </button>
        ) : null}
        {onNext ? (
          <button className='flex bg-white text-primaryDark1 py-8 px-12 space-x-8 rounded-8' onClick={onNext}>
            <span>{trans('next')}</span>
            <i className='icon-chevron-right-bolder' />
          </button>
        ) : null}
        {onValidate ? (
          <button className='mx-auto bg-white text-primaryDark1 py-8 px-12 space-x-8 rounded-8' onClick={onValidate}>
            <span>J'ai compris</span>
          </button>
        ) : null}
      </div>
    </div>
  )
}

ModalTutorial.defaultProps = {
  position: 'left',
}

export default ModalTutorial
